import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import { useNavigate } from "react-router-dom";
import { confirmPaymentandGenerateReceipt, fetchPayment, setAmount, setPaymentVerificationState } from '../slices/payment.slice';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { removeComma, separateNumber } from '../helpers/mmg';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ErrorIcon from '@mui/icons-material/Error';
import { useParams, useLocation  } from 'react-router-dom';
import queryString from 'query-string';
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import moment from 'jalali-moment'
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CircularProgress from '@mui/material/CircularProgress';

export const zeroPad = (num, places) => String(num).padStart(places, '0');

const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};


export const CallBack = (props) => {


  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))
  const payment = useSelector(x => x.payment);
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  let navigate = useNavigate();

  let location = useLocation();
  console.log("params");
  console.log(location.search);
  console.log(new URLSearchParams(location.search).get("RefId"));
  console.log(new URLSearchParams(location.search).get("ResCode"));
  console.log(new URLSearchParams(location.search).get("SaleOrderId"));
  console.log(new URLSearchParams(location.search).get("SaleReferenceId"));

  let RefId = new URLSearchParams(location.search).get("RefId");
  let ResCode = new URLSearchParams(location.search).get("ResCode");
  let SaleOrderId = new URLSearchParams(location.search).get("SaleOrderId");
  let SaleReferenceId = new URLSearchParams(location.search).get("SaleReferenceId");

  let oldPosRefId = localStorage.getItem('oldPosRefId');
  let oldOrderId = localStorage.getItem('oldOrderId');
  let amount = localStorage.getItem('amount');


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    //color: theme.palette.text.secondary,
  }));
  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");



   useEffect(() => {
      
      setTimeout(function(){
        if (oldPosRefId == RefId && ResCode.toString() === "0")
        {
  
  
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, '0');
          var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
          var yyyy = today.getFullYear();
          today = yyyy + '-' +  mm + '-' + dd;
          console.log("today1 " + today);
          
          dispatch(confirmPaymentandGenerateReceipt(
          {
              Number: payment.paymentVerificationNumber,
              Amount : parseInt(removeComma(amount)) ,
              ItemDescription : `بابت دریافت وجه از تراکنش ${payment.paymentVerificationNumber}` ,
              CurrencyId : defaultValues.CurrencyId,
              Description : `بابت دریافت وجه از تراکنش ${payment.paymentVerificationNumber}` ,
              Date : today,
              SaleReferenceId : SaleReferenceId,
              SaleOrderId : SaleOrderId,
              oldOrderID : oldOrderId,
              authUser,
          }
          ));
  
        }else{
  
          dispatch(setPaymentVerificationState(2));
  
        }
      }, 500); //ru
     


   }, []);



   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
});

const onBackClicked = (e) =>{

  navigate('/invoices');

}





const handleClick = (e) =>{
/*
  e.preventDefault();
  if(parseInt(removeComma(payment.amount))){
    const rndInt = Math.floor(Math.random() * 6000) + 1000
    dispatch(fetchPayment({orderId: rndInt, amount : parseInt(removeComma(payment.amount)) , authUser}));
  }
*/
  
}

// Random component
const Completionist = () =>   
{
  payment.setPaymentVerificationState === 1 ? 
<Typography variant="h6" component="div">
  <AttachMoneyIcon sx={{ color: "#3F51B5" }} />   عملیات پرداخت با موفقیت انجام شد  {payment.paymentVerificationNumber}  مبلغ  {amount} ریال 
</Typography>
  :
<Typography variant="h6" component="div">
  <AttachMoneyIcon sx={{ color: "#3F51B5" }} />   عملیات پرداخت با خطا مواجه شد  {payment.paymentVerificationNumber}  مبلغ  {amount} ریال 
</Typography>
} 
;

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
   
    
  console.log("Render Complete");
 
    return <Completionist />;
  } else {
    // Render a countdown
    return <span>{hours}:{minutes}:{seconds}</span>;
  }
};

  return (
    <>

<ThemeProvider theme={mdTheme}>
<br/><br/><br/><br/><br/><br/>
  <Box sx={{ flexGrow: 1 }}>
  <Grid container
    justify="center"
    style={{ minHeight: '100vh' }}
  >
              <Grid item xs={12}>
                       
 {payment.loading ?   <Backdrop 
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>  : "" }


        <Card sx={{ minWidth: 275 }}>
      <CardContent>

        {
        /*<Countdown
                date={Date.now() + 5000}
                renderer={renderer}
              />
        */}
          

      {payment.error ? 
      <Typography component="div" sx={{ color: "#E53935" }}>
        <ErrorIcon sx={{ color: "#E53935" }} />خطا در ارسال درخواست &nbsp; {payment.errorMessage}
        </Typography>  : "" }
        <br/>
        {
        payment.paymentVerificationState === 1 ? 
        <Typography variant="h6" component="div">
          <FileDownloadDoneIcon sx={{ color: "#43A047" }} />   عملیات پرداخت با موفقیت انجام شد  {payment.paymentVerificationNumber}  مبلغ  {amount} ریال 
        </Typography>
          :
          (payment.paymentVerificationState === 2 ?
          <Typography component="div" sx={{ color: "#E53935" }}>
        <ErrorIcon sx={{ color: "#E53935" }} /> عملیات پرداخت با خطا مواجه شد  {payment.paymentVerificationNumber}  مبلغ  {amount} ریال . 
        مبلغ پرداختی شما حداکثر ظرف ۴۸ ساعت به حساب شما باز خواهد گشت.
        </Typography>
        :  (payment.loading ?
        <Typography component="div" sx={{ color: "#283593" }}>
          <CircularProgress sx={{ color: "#283593" }} />
           در حال بررسی تراکنش
        </Typography> : ""
        )
        
        )
       
        } 

      </CardContent>
    
    </Card>
        
</Grid>
</Grid>
    </Box>
    </ThemeProvider>
    </>
  );
}

export default CallBack;